import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import mixpanel from 'mixpanel-browser';
import {selectCurrentUser} from 'src/modules/main/services/user-info-slice';

import type {Config} from 'mixpanel-browser';

const MIX_PANEL_INIT_OPTIONS: Partial<Config> = {
    track_pageview: false,
    persistence: 'localStorage',
    record_sessions_percent: 100,
    record_mask_text_selector: '.fs-disable',
};

let mixpanelInitialized = false;

export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
    if (mixpanelInitialized) {
        mixpanel.track(eventName, properties);
    }
};

export const Mixpanel = () => {
    const user = useSelector(selectCurrentUser);
    const userId = user?.userId;
    const MIX_PANEL_TOKEN = process.env.MIX_PANEL_TOKEN;
    // const isProd = process.env.NODE_ENV === 'production';

    useEffect(() => {
        if (userId && MIX_PANEL_TOKEN) {
            mixpanel.init(MIX_PANEL_TOKEN, MIX_PANEL_INIT_OPTIONS);
            mixpanel.identify(userId.toString());
            mixpanelInitialized = true;
        }
    }, [userId, MIX_PANEL_TOKEN]);

    return null;
};
